import { RgChildren as C, RG_TYPE as r, GetAllJoints as g } from "@project-rouge/rg-core";
import { getBoundaryOfObjects as v } from "./index4.js";
function G({
  building: a,
  bone: n,
  level: d = 0,
  childrenToInclude: e,
  includeCornerCores: o = "ifTallest"
}) {
  e ?? (e = [...C.Building, r.Module]);
  const m = [d], i = n.joints.map((t) => t.id), f = n.muscles.map((t) => t.id), p = n.tendon.id, u = a.children.filter((t) => m.includes(t.data.level));
  if (u.length === 0)
    return [];
  const l = u.filter((t) => e == null ? void 0 : e.includes(t.type));
  if (l.length === 0)
    return [];
  const y = g(a.data.anatomy), j = l.filter((t) => {
    if (t.type === r.Core && t.data.isCorner) {
      if (o === "never")
        return !1;
      const D = y.find((s) => s.id === t.data.jointID);
      return i.includes(t.data.jointID) ? o === "always" ? !0 : !D.bones.some((s) => s.floors > n.floors) : !1;
    }
    return t.type === r.Core ? i.includes(t.data.jointID) || f.includes(t.data.muscleID) : t.type === r.Corridor ? p === t.data.tendonID : "muscleID" in t.data ? f.includes(t.data.muscleID) : !1;
  });
  return v(j, e);
}
export {
  G as getBoneBoundary
};
//# sourceMappingURL=index2.js.map
